import React from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../pages/home-redesign/constants';
import { IconApple, IconGooglePlayMark } from '../pages/home-redesign/HomeRedesignIcons';
import { useHomeRedesignStrings } from '../pages/home-redesign/useHomeRedesignStrings';

type PlansDownloadCtaProps = {
  title: string;
  body: string;
};

const PlansDownloadCta: React.FC<PlansDownloadCtaProps> = ({ title, body }) => {
  const f = useHomeRedesignStrings().finalCta;

  return (
    <section
      className="mt-16 overflow-hidden rounded-[32px] px-6 py-10 text-center sm:px-10 sm:py-12 md:rounded-[40px]"
      style={{
        backgroundImage:
          'linear-gradient(129deg, rgb(255, 217, 238) 0%, rgb(255, 192, 225) 100%)',
      }}
    >
      <h2 className="font-instrument text-3xl leading-tight tracking-[-0.02em] text-[#2a0f2a] sm:text-4xl md:text-5xl">
        {title}
      </h2>
      <p className="mx-auto mt-4 max-w-lg font-jakarta text-base leading-relaxed text-[#5a3158] md:text-lg">
        {body}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-2.5">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] bg-[#2a0f2a] px-4 font-jakarta text-white transition-transform hover:scale-[1.02]"
        >
          <IconApple className="size-6 shrink-0 text-white" />
          <span className="flex flex-col items-start leading-tight">
            <span className="text-[10px] font-medium opacity-75">{f.downloadOn}</span>
            <span className="text-base font-bold tracking-[-0.01em]">{f.appStore}</span>
          </span>
        </a>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] bg-[#2a0f2a] px-4 font-jakarta text-white transition-transform hover:scale-[1.02]"
        >
          <IconGooglePlayMark className="size-6 shrink-0" />
          <span className="flex flex-col items-start leading-tight">
            <span className="text-[10px] font-medium opacity-75">{f.getItOn}</span>
            <span className="text-base font-bold tracking-[-0.01em]">{f.googlePlay}</span>
          </span>
        </a>
      </div>
    </section>
  );
};

export default PlansDownloadCta;
